import dynaForms from '@elab/core/utils/dynaForms';
import { initialState as dynaInitialState } from '@elab/core/utils/dynaForms/reducers';

import getTypes from './types';

export const initialState = (state, initialData) => ({
    ...dynaInitialState(state),
    isPinCodeOrDOBValid: true,
    isPinCodeAndDOBFilled: false,
    ...initialData,
});

const createReducer = storeName => {
    const dynaFormReduce = dynaForms.createReducer(storeName);
    const types = getTypes(storeName);

    return (state = initialState(), action) => {
        state = dynaFormReduce(state, action);
        switch (action.type) {
            case types.AFTER_INITIALIZE: {
                return dynaForms.afterInitializeReduce(state);
            }

            case types.SET_METADATA: {
                return {
                    ...state,
                    metadata: [...(action.payload || [])],
                };
            }

            case types.SET_IS_PIN_CODE_OR_DOB_VALID:
                return {
                    ...state,
                    ...action.payload,
                };

            default:
                return state;
        }
    };
};

export default createReducer;
